import script from "./delPrompt.vue?vue&type=script&setup=true&lang=ts"
export * from "./delPrompt.vue?vue&type=script&setup=true&lang=ts"

import "./delPrompt.vue?vue&type=style&index=0&id=0ea07939&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ea07939"]])

export default __exports__